import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Side.css";

export default function Side() {
    const [icona, setIcona] = useState("eye")
    const [stato, setStato] = useState("flex")


    const nascondi = () => {
        if (icona == "eye") {
            setStato("none")
            setIcona("eye-off")
        }
        if (icona == "eye-off") {
            setStato("flex")
            setIcona("eye")
        }
    }

    return (
        <>
            <div className="showMenu">
                <ion-icon name={icona} id="showIcon" onClick={() => nascondi()} />
            </div>
            <aside style={{ display: stato }}>
                <article className="laterale">
                    <img src="https://infislab.it/foto/logo.png" className="logo"></img>
                    <br /><br />
                    <h2> Diamo alla tua casa <b>la sicurezza e l'eleganza</b> che merita.
                        Rendi unico ogni tuo spazio, con i migliori infissi e le migliori porte.
                    </h2>
                    <br />
                    <div className="icons">
                        <a href="https://it-it.facebook.com/infislab/" target="_blank">
                            <ion-icon id="icone_side" name="logo-facebook"></ion-icon>
                        </a>
                        <a href="mailto:infislab@gmail.com">
                            <ion-icon id="icone_side" name="mail-outline"></ion-icon>
                        </a>
                        <a href="tel:+393288921372">
                            <ion-icon id="icone_side" name="call-outline"></ion-icon>
                        </a>
                        <Link to="/about/showroom">
                            <ion-icon id="icone_side" name="location-outline"></ion-icon>
                        </Link>
                    </div>
                    <br />
                    <h3>
                        <i> "Bisogna lavorare e osare se si vuole vivere veramente"
                            - V. Van Gogh </i>
                    </h3>
                </article>
            </aside>
        </>
    )
}